import { differenceInCalendarDays } from 'date-fns';

export const defaultOptions = [
  { id: 'D', label: 'Day', minDate: 31 },
  { id: 'W', label: 'Week', minDate: 91 },
  { id: 'M', label: 'Month', minDate: 366 },
  { id: 'Q', label: 'Quarter' },
  { id: 'Y', label: 'Year' },
];

export const shortDate = {
  past1d: 1,
  past7d: 7,
  past30d: 30,
  past3m: 90,
  past12m: 360,
};

const getDaysBetween = (from, to) => {
  const shortKeys = Object.keys(shortDate);
  if (shortKeys?.includes(from)) {
    return shortDate[from];
  }
  const daysInBetween = differenceInCalendarDays(new Date(to), new Date(from));
  return daysInBetween;
};

export const getOptions = ({ from, to }) => {
  const diffDays = getDaysBetween(from, to);
  const result = defaultOptions?.filter((options) => {
    if (!options?.minDate) return true;
    if (options?.minDate > diffDays) return true;
    return false;
  });
  return result;
};

export const getDefaultView = (from, to) => {
  const option = getOptions({ from, to });
  return option[0]?.id;
};
